import React from 'react'
import { removeKeywordSuffix } from 'containers/VerticalPage/common/utils'
import columns from '../../UI/VerticalTable/columns'
import { COLUMNS_IDS } from 'UI/VerticalTable/utils'
import { InfoCircleOutlined } from '@ant-design/icons'
import AntdTooltip from 'UI/Tooltip/Tooltip'

export const ecommerceColumns = [
  {
    ...columns[COLUMNS_IDS.profileNames],
    title: (
      <>
        <span>Online Name</span>
        <AntdTooltip title='Names used by entity/individual online' placement='bottom' color='#fff'>
          <InfoCircleOutlined style={{ color: '#B8AFAF', marginLeft: '6px' }} />
        </AntdTooltip>
      </>
    ),
  },
  columns[COLUMNS_IDS.verifiedName],
  columns[COLUMNS_IDS.tin],
  columns[COLUMNS_IDS.reportStatus],
  columns[COLUMNS_IDS.unreportedRevenue],
  columns[COLUMNS_IDS.reported],
  { ...columns[COLUMNS_IDS.totalRevenue], title: 'Total Revenue' },
  columns[COLUMNS_IDS.ecommerceDocumentedRevenue],
  columns[COLUMNS_IDS.ecommerceEstimatedRevenue],
  columns[COLUMNS_IDS.ecommerceCollectsSalesTax],
  columns[COLUMNS_IDS.dataSources],
  columns[COLUMNS_IDS.activityType],
  columns[COLUMNS_IDS.firstActivity],
  columns[COLUMNS_IDS.caseId],
  columns[COLUMNS_IDS.ecommerceTotalSoldItems],
  columns[COLUMNS_IDS.ecommerceTotalReviews],
]

export const keysForEmptyColumnsRequest = removeKeywordSuffix(
  ecommerceColumns.map(el => `${el.key}` || '').filter(key => Boolean(key)),
)
